import React from "react"
import { Script } from "gatsby"

import useJustunoTracking from "hooks/useJustunoTracking"
import { organizationSchema, websiteSchema } from "utils/organizationSchema"

import Helmet from "react-helmet"
import Footer from "../footer"
import {
  GlobalStyles,
  Container,
  TopAccessibilityContainer,
  TopAccessibilityLink,
  Separator,
} from "./styles"

const TIE_GTM_SCRIPT =
  `!function(){"use strict";function l(e){for(var t=e,r=0,n=document.cookie.split(";");r<n.le` +
  `ngth;r++){var o=n[r].split("=");if(o[0].trim()===t)return o[1]}}function s(e){return local` +
  `Storage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector` +
  `(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=` +
  `document,r="script",n="dataLayer",o="https://ss3.zone.mindbodygreen.com",a="",i="88x2wufxr` +
  `vmc",c="3=CglLNSwrWCc7Lk4iKzImURVQRFxJQBEZXgAfHBwEGhMaCgQXHQhbFAwA",g="stapeUserId",v="",E` +
  `="",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp("Version/([0-9._]+)(.*Mobil` +
  `e)?.*Safari.*").exec(m)))&&16.4<=parseFloat(m[1]),f="stapeUserId"===g,I=d&&!f?function(e,t` +
  `,r){void 0===t&&(t="");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.` +
  `isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o` +
  `(c);if(c)return c}else console.warn("invalid uid source",e)}(g,v,E):void 0;d=d&&(!!I||f)}c` +
  `atch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({"gtm.start":(new Date).getTim` +
  `e(),event:"gtm.js"}),t.getElementsByTagName(r)[0]),v=I?"&bi="+encodeURIComponent(I):"",E=t` +
  `.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,"kp$1"):"kp"+i),!d&&a?a:o);E` +
  `.async=!0,E.src=f+"/"+i+".js?"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();`
const Layout = ({ children }) => {
  useJustunoTracking()

  const website = (
    <script data-scheme="WebSite" type="application/ld+json">
      {JSON.stringify(websiteSchema)}
    </script>
  )

  const org = (
    <script data-scheme="Organization" type="application/ld+json">
      {JSON.stringify(organizationSchema)}
    </script>
  )

  return (
    <>
      <Helmet>
        {org}
        {website}
        <script src="https://www.dwin1.com/19038.js" type="text/javascript" defer="defer" />
      </Helmet>
      <Script id="refersion-tracking">
        {`
          (function (w,d,s,u,o,c,e,x) {
            w['TrackingSystemObject']=o;
            e=d.createElement(s);e.async=1;e.src=u;e.onload=c;x=d.getElementsByTagName(s)[0];
            x.parentNode.insertBefore(e, x);
          })(window,document,'script','https://cdn.refersion.com/refersion.js','r',function () {
            r.pubKey = 'pub_ff8495c9ec635f6d582b';
            r.initializeXDLS().then(() => {
              r.launchDefault();
            });
          });
        `}
      </Script>
      <Script id="tie-gtm">{TIE_GTM_SCRIPT}</Script>
      <GlobalStyles />
      <TopAccessibilityContainer>
        <TopAccessibilityLink href="#content" aria-label="Skip to content">
          Skip to Content
        </TopAccessibilityLink>
        <Separator />
        <TopAccessibilityLink
          href="/accessibility"
          target="_blank"
          aria-label="Accessibility Statement"
        >
          Accessibility Statement
        </TopAccessibilityLink>
      </TopAccessibilityContainer>
      <Container>
        {children}
        <Footer />
      </Container>
    </>
  )
}

export default Layout
